// src/components/Layout.jsx
import React, { useState } from 'react';
import { Box, AppBar, Toolbar, Typography, IconButton, Breadcrumbs, Link, alpha } from '@mui/material';
import { Menu, Notifications, NavigateNext } from '@mui/icons-material';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import Sidebar from './Sidebar';

const DRAWER_WIDTH      = 20;
const DRAWER_WIDTH_MINI = 72;

const BREADCRUMB_MAP = {
  dashboard:  'Dashboard',
  activity:   'Field Activity',
  tasks:      'Tasks',
  analytics:  'Analytics',
  users:      'Users',
  settings:   'Settings',
  trash:      'Trash',
  export:     'Export',
};

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();

  const crumbs = location.pathname
    .split('/')
    .filter(Boolean)
    .map((seg, i, arr) => ({
      label: BREADCRUMB_MAP[seg] || seg,
      path:  '/' + arr.slice(0, i + 1).join('/'),
    }));

  const drawerW = sidebarOpen ? DRAWER_WIDTH : DRAWER_WIDTH_MINI;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', background: '#fff' }}>
      <Sidebar open={sidebarOpen} onToggle={() => setSidebarOpen((p) => !p)} />

      <Box sx={{
        flex: 1,
        ml: `${drawerW}px`,
        transition: 'margin-left 0.25s ease',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}>
        {/* Top bar */}
        {/* <AppBar position="sticky" elevation={0} sx={{
          background: 'rgba(255,255,255,0.9)',
          backdropFilter: 'blur(20px)',
          borderBottom: '1px solid rgba(16,117,186,0.1)',
          zIndex: 1100,
        }}>
          <Toolbar sx={{ minHeight: '64px !important', px: 3, gap: 2 }}>
            <Breadcrumbs
              separator={<NavigateNext fontSize="small" sx={{ color: '#3a5a7a' }} />}
              sx={{ flex: 1 }}
            >
              {crumbs.map((c, i) => i < crumbs.length - 1 ? (
                <Link
                  key={c.path}
                  component={RouterLink}
                  to={c.path}
                  underline="hover"
                  sx={{ fontSize: '0.875rem', color: '#4a6a85', '&:hover': { color: '#1075BA' } }}
                >
                  {c.label}
                </Link>
              ) : (
                <Typography key={c.path} sx={{ fontSize: '0.875rem', fontWeight: 600, color: '#0f2137' }}>
                  {c.label}
                </Typography>
              ))}
            </Breadcrumbs>

            <IconButton size="small" sx={{
              color: '#4a6a85',
              background: 'rgba(16,117,186,0.08)',
              border: '1px solid rgba(16,117,186,0.15)',
              borderRadius: '10px',
              width: 36, height: 36,
              '&:hover': { background: 'rgba(16,117,186,0.15)', color: '#1075BA' },
            }}>
              <Notifications fontSize="small" />
            </IconButton>
          </Toolbar>
        </AppBar> */}

        {/* Page content */}
        <Box sx={{ flex: 1, p: 3, overflowX: 'hidden' }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}
